import * as React from "react"
const SvgBolt = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m10.55 18.629 5.175-6.2h-4l.725-5.675-4.625 6.675H11.3zM9 15.429H5.9q-.6 0-.888-.538-.287-.537.063-1.037l7.475-10.75q.25-.35.65-.488a1.22 1.22 0 0 1 .825.013q.425.15.625.525c.2.375.183.516.15.8l-.8 6.475h3.875q.65 0 .913.575.261.574-.163 1.075l-8.225 9.85a1.27 1.27 0 0 1-.675.425 1.13 1.13 0 0 1-.775-.075 1.3 1.3 0 0 1-.588-.538 1.23 1.23 0 0 1-.162-.787z" />
  </svg>
)
export default SvgBolt
